import { StackScreenProps } from "@react-navigation/stack";
import { ManageProductTagsRootParamList } from "../../../../types";
import { ProductFormValues } from "../../components/ProductForm/types";
import { useFormContext } from "react-hook-form";
import React from "react";
import { Button, Page, TextField } from "@towersystems/roam-common-native";

export type AddProductTagScreenProps = StackScreenProps<
  ManageProductTagsRootParamList,
  "AddProductTagScreen"
>;

export const AddProductTagScreen = ({
  navigation,
}: AddProductTagScreenProps) => {
  const [input, setInput] = React.useState<string>("");
  const { setValue, getValues } = useFormContext<ProductFormValues>();

  const isDirty = React.useMemo(() => {
    return input !== "";
  }, [input]);

  const handleOnSubmit = React.useCallback(() => {
    const existingTags = getValues().tags;
    const tags = [...existingTags, input];
    setValue("tags", tags, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, [input]);

  React.useEffect(() => {
    const disabled = !isDirty;
    navigation.setOptions({
      headerRight: () => {
        return (
          <Button
            label="Add Tag"
            isAction
            disabled={disabled}
            onPress={handleOnSubmit}
            size="compact"
          ></Button>
        );
      },
    });
  }, [handleOnSubmit, isDirty]);

  const handleOnInputChange = React.useCallback(
    (input: string) => {
      setInput(input);
    },
    [setInput]
  );

  return (
    <Page scrollable={false} cover>
      <TextField
        value={input ?? ""}
        onChangeText={handleOnInputChange}
        placeholder="Enter tag"
        filled={false}
      />
    </Page>
  );
};
